const Request = require('@/repositories/request')
const qs = require('qs')

class BusinessArea extends Request {
  /**
   *
   * @param {int} id
   * @returns {*}
   */
  findOne(id) {
    return this.$strapi['$business-areas'].findOne(id)
  }

  /**
   *
   * @param {Object} params
   * @return {*}
   */
  findAll(params) {
    const stringifyParams = qs.stringify({ ...params }, { encode: false })
    return this.$strapi['$business-areas'].find(stringifyParams)
  }
}

module.exports = BusinessArea
